import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DesiriBullsSearch from "./desiri-bulls-search";
import DesiriBullsTable from "./desiri-bulls-table";
import desiriBullService from "../../services/desiriBull/bullservice";
import { Bull, DesiriBullDTO } from "../../models/oilProduction-model";
import { BreadCrumb } from "primereact/breadcrumb";

const DesiriBullsPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [bulls, setBulls] = useState<DesiriBullDTO[]>([]);
  const [filteredBulls, setFilteredBulls] = useState<DesiriBullDTO[]>([]);

  useEffect(() => {
    fetchBulls();
  }, []);

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText, bulls]);

  const fetchBulls = async () => {
    debugger
    try {
      const res = await desiriBullService.getAllBulls();
      setBulls(res);
    } catch (error) {
      console.error("API error:", error);
      setBulls([]);
    }
  };

  const handleSearch = (text: string) => {
    const terms = text.toLowerCase().trim().split(/\s+/);
    const filtered = bulls.filter((b) => {
      const line = Object.values(b).join(" ").toLowerCase();
      return terms.every((term) => line.includes(term));
    });
    setFilteredBulls(filtered);
  };
  const breadcrumbItems = [
    { label: "Desiri Master Data", url: "" },
    { label: "Desiri Bull", url: "" },
  ];
  const home = { icon: "pi pi-home", url: "/" };

  return (
    <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
      <div className="col-12">
        <h4 className="ml-1 mb-0">{t("Add Bull")}</h4>
      </div>
      {/* <BreadCrumb
        model={breadcrumbItems}
        home={home}
        className=" mb-2 bg-transparent px-0 py-0 text-sm  text-gray-600"
        style={{
          border: "none",
          boxShadow: "none",
          background: "transparent",
          marginLeft: "11px",
        }}
      /> */}
      <DesiriBullsSearch onSearch={setSearchText} onRefresh={fetchBulls} />
      <DesiriBullsTable data={filteredBulls} onRefresh={fetchBulls} />
    </div>
  );
};

export default DesiriBullsPage;
